import { render, staticRenderFns } from "./MainIndex.vue?vue&type=template&id=9103ef6a&scoped=true"
import script from "./MainIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MainIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MainIndex.vue?vue&type=style&index=0&id=9103ef6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9103ef6a",
  null
  
)

export default component.exports